import { Geometry, LineString, Polygon } from 'ol/geom'
import { ToolEnum } from '../model/tool.enum'
import { MeasureUtils } from './measure.utils'
import { Coordinate } from 'ol/coordinate'

export class TooltipUtils {
    static getTooltipLabel(geometry: Geometry) {
        const geometryType = geometry.getProperties()['type']
        if (geometryType === ToolEnum.Surface) {
            const polygon = geometry as Polygon
            return MeasureUtils.computeArea(polygon) + 'm<sup>2</sup><br>' + MeasureUtils.computePerimeter(polygon) + 'm'
        }
        if (geometryType === ToolEnum.Azimuth) {
            return MeasureUtils.computeAzimuth(geometry as LineString) + '°'
        }
        if (
            geometryType === ToolEnum.Length ||
            geometryType === ToolEnum.GenericDistance ||
            geometryType === ToolEnum.PrivateTrenchEnrobee ||
            geometryType === ToolEnum.PrivateTrenchNaturel ||
            geometryType === ToolEnum.PrivateTrenchToiture
        ) {
            const length = Math.round(MeasureUtils.computeLength(geometry as LineString) * 100) / 100
            if (geometryType === ToolEnum.PrivateTrenchEnrobee) {
                return 'Enrobée : ' + length + 'ml'
            }
            if (geometryType === ToolEnum.PrivateTrenchNaturel) {
                return 'Terrain naturel : ' + length + 'ml'
            }
            if (geometryType === ToolEnum.PrivateTrenchToiture) {
                return 'Toiture : ' + length + 'ml'
            }
            return length + 'm'
        }
        return ''
    }

    static getTooltipPosition(geometry: Geometry): Coordinate {
        const geometryType = geometry.getProperties()['type']
        if (geometryType === ToolEnum.Surface) {
            return (geometry as Polygon).getInteriorPoint().getCoordinates()
        }
        if (
            geometryType === ToolEnum.Azimuth ||
            geometryType === ToolEnum.Length ||
            geometryType === ToolEnum.PrivateTrenchEnrobee ||
            geometryType === ToolEnum.PrivateTrenchNaturel ||
            geometryType === ToolEnum.PrivateTrenchToiture || 
            geometryType === ToolEnum.GenericDistance
        ) {
            return (geometry as LineString).getFlatMidpoint()
        }
        return null
    }
}
